import { createContext } from 'react';
import { EventTemplateSummary } from '../../shared/payloads';

export type StorageContextType = { event?: EventTemplateSummary };
export const StorageContext = createContext<StorageContextType>({});
